export type PageData = ProductInfoType

export enum Has {
  No,
  Yes
}

/**
 * 商品alsoView 类型声明
 * @types-AlsoView
 * AlsoViewType form AlsoView Api
 */
export type AlsoViewType = {
  productList: {
    productsId: string
    productsSkuId: string
    poa: string
    productsName: string
    mainImage: string
    hoverImage: string
    finalPrice: number
    formatFinalPrice: string
    marketPrice: number
    formatMarketPrice: string
    jumpUrl: string
    starScore: string
    reviewNum: string
    stocks: number
    showDispatch: string
    saveMoneyDesc: string
    productsStatus: number
    activityInfo: any
  }[]
}
/* @types-AlsoView */

/**
 * 商品详情 类型声明
 * @types-ProductInfo
 * ProductInfoType form ProductInfo Api
 */
export type ProductInfoType = {
  productInfo: {
    categoriesNames: string
    sourceImageList: {
      imagePath: string
      type: number
    }[]
    fscInfo
    priceColor
    collectionMap
    overviewAttrs: {
      optionsSort: string
      overviewImage: string
      productsOptionsId: string
      productsOptionsName: string
      productsOptionsValuesId: [string]
      productsOptionsValuesName: string
      isFsc: 1 | 0
    }[]
    aPlusConfig
    shippingInfo: {
      freeShippingUrl
      returnPolicyUrl
    }
    freeShippingDesc
    postagePrice
    postagePriceFormat
    freeShippingWarn
    isFreeShipping
    url
    feedDesc
    brandName
    salePoint
    categoryId
    reviewScore
    highlights: any[]
    productsId: string
    customTips: string
    productsSkuId: string
    poa: string
    productsName: string
    productsSubtitle: string
    productsDescription: string
    metaTitle: string
    metaDescription: string
    metaKeyword: string
    currency: string
    salePrice: string
    formatSalePrice: string
    formatOriginalSalePrice: string
    usPrice: number
    marketPrice: string
    formatMarketPrice: string
    presalePrice: string
    formatPresalePrice: string
    saveMoneyDesc: string
    imageList: {
      coverImage?: string
      imagePath: string
      type: number
      isWeights?
      is3D?
      alt?: string
    }[]
    productsStatus: number
    isOutStockCanBuy: number
    deliveryTime?: string
    presaleDeliveryTime?: string
    deliveryTimeImage?: string
    productsAuthorityUrl: string
    stocks: number
    status: number
    starScore: string
    reviewNum: string
    saleAttrs: {
      productsOptionsId: string
      optionsSort: string
      productsOptionsName: string
      productsOptionsValuesId: string
      productsOptionsValuesName: string
    }[]
    paramsAttrs: any[]
    specInfo: {
      specImageList: string[]
      specImagePath: string
      specItemList: { name: string; value: string[]; isDimension?: boolean }[]
    }
    fileList: any[]
    yotpo: {
      appKey: 'k4TvtXDbRmSUYYiDrk99BZYbw1QXl4GMGHNoVOWO'
      dataImageUrl: 'hernest.com'
      dataUrl: 'https://hernest.com'
      pid: 'HEFTCH-8074'
    }
    isCart?: boolean
    isDrawer?: boolean
    // 活动标签
    productTag?: {
      backgroundColor: string
      fontColor: string
      tagName: string
      redirectUrl?: string
    }
    productTags: {
      backgroundColor: string
      fontColor: string
      tagName: string
      redirectUrl?: string
      /**
       * 4=标题上方
       * 7=价格前
       */
      position: 4 | 7
    }[]
  }
  productActTag
  saleAttrList: {
    productsOptionsId: string
    optionsSort: string
    optionsValueType: string
    productsOptionsName: string
    optionsValuesList: {
      productsOptionsValuesId: string
      productsOptionsValuesName: string
      optionsValuesSort: string
    }[]
  }[]
  skuList: {
    1: {
      productsSkuId: string
      productsId: string
      poa: string
      imagePath: string
      attrIds: {
        1: number
      }
      jumpUrl: string
    }
  }
  saleAttrValueMap: Type.DefineObject
  navBread: {
    title: string
    href: string
  }[]
  accInfo: {
    minProductNum: string
    accProductList: {
      index?
      skuId: string
      checked: boolean
      productsId: string
      productsSkuId: string
      poa: string
      productsName: string
      mainImage: string
      hoverImage: string
      finalPrice: number
      formatFinalPrice: string
      marketPrice: number
      discountPrice: string
      formatMarketPrice: string
      jumpUrl: string
      starScore: string
      reviewNum: string
      stocks: number
      showDispatch: string
      saveMoneyDesc: string
      productsStatus: number
      groupPrice: string
      isMain: string
    }[]
  }
  activityInfo: any
  relateSpuInfo?: {
    attrName?: string | undefined
    attrValue?: string | undefined
    list?: any[]
    spuId?: number | string
  }
}
/* @types-ProductInfo */

export type TogetherData = ProductInfoType['accInfo']

/**
 * 添加收藏 类型声明
 * @types-AddWish
 * AddWishType form AddWish Api
 */
export type AddWishType = []
/* @types-AddWish */
/**
 * 取消收藏 类型声明
 * @types-RemoveWish
 * RemoveWishType form RemoveWish Api
 */
export type RemoveWishType = []
/* @types-RemoveWish */

/* @types-WishList */
/**
 * 收藏列表 类型声明
 * @types-WishList
 * WishListType form WishList Api
 */
export type WishListType = {
  page: number
  pageSize: number
  pageTotal: number
  productlist: []
}
/* @types-WishList */

export interface MatchList {
  products_add_time: string
  dispatch_tips: DispatchTips
  products_id: string
  products_sku_id: string
  poa: string
  products_name: string
  main_image: string
  hover_image: string
  spec_image: string
  final_price: number
  is_free_shipping: number
  format_final_price: string
  market_price: number
  format_market_price: string
  style_format_final_price: string
  jump_url: string
  categories_names: string
  categories_id_list: number[]
  categories_id: any[]
  star_score: number
  review_num: number
  stocks: number
  save_money_desc: string
  products_status: number
  options_desc: string
  is_show_spu: string
  more_sku_num: number
  is_wish: number
  sale_options: string[]
}

export interface DispatchTips {
  is_show_delivery_time: string
  is_show_custom_tips: string
  custom_tips: string
  install_position: string
}
